import styled from 'styled-components';
import {dFlexCenter, dFlexColumn} from '../../../../globalVariables/GlobalFlex';

export const wrap = styled.div`
    ${dFlexColumn}
    gap: var(--space-lg);
    width: 100%;
`;

export const viewport = styled.div`
    position: relative;
    width: 100%;
    height: 240px;
    overflow: hidden;
    border-radius: var(--border-radius-border-radius-md);
    background: var(--color-bg-surface-default);
    touch-action: none;
    cursor: grab;

    &:active {
        cursor: grabbing;
    }

    svg rect {
        fill: var(--color-border-subtle);
    }

    svg rect.is-mine {
        fill: #FFCC00;
    }

    svg .seat-x {
        fill: none;
        stroke: var(--primitive-black-30);
        stroke-width: 1;
        stroke-linecap: round;
    }

    svg text {
        fill: var(--color-text-default);
        font-size: 7px;
        font-weight: var(--font-weight-bold);
    }

    svg text.row-num {
        fill: var(--primitive-gray-500, #8a8a8a);
        font-size: 8px;
    }
`;

export const canvas = styled.div`
    position: absolute;
    inset: 0;
    ${dFlexCenter}
    transform-origin: center center;

    svg {
        flex: none;
    }
`;

export const controls = styled.div`
    ${dFlexCenter}
    gap: var(--space-md);
    width: 100%;
`;

export const slider = styled.div`
    ${dFlexCenter}
    direction: ltr;
    gap: var(--space-sm);
    flex: 1;
    height: 44px;
    padding-inline: var(--space-md);
    border-radius: var(--border-radius-border-radius-full);
    background: var(--primitive-gray-100);

    input {
        flex: 1;
        -webkit-appearance: none;
        appearance: none;
        height: 4px;
        border-radius: var(--border-radius-border-radius-full);
        background: var(--primitive-gray-300);
        cursor: pointer;
    }

    input::-webkit-slider-thumb {
        -webkit-appearance: none;
        appearance: none;
        width: 22px;
        height: 22px;
        border-radius: 50%;
        background: var(--color-bg-base);
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
        cursor: pointer;
    }

    input::-moz-range-thumb {
        width: 22px;
        height: 22px;
        border: none;
        border-radius: 50%;
        background: var(--color-bg-base);
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
        cursor: pointer;
    }
`;

export const iconBtn = styled.button`
    flex: none;
    ${dFlexCenter}
    padding: 0;
    border: none;
    background: none;
    color: var(--color-text-default);
    cursor: pointer;
`;
